'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SCREEN_DATA_ACTION = undefined;

var _ScreenKeyConst = require('../../../components/screen/ScreenKeyConst');

var SET_SCREEN_DATA_ACTION = exports.SET_SCREEN_DATA_ACTION = 'SET_SCREEN_DATA_ACTION';

/**
 * Sets screen data
 * @param {string[]} path 
 * @param {any} value 
 * @param {string} [screenKey] 
 */
var setScreenData = function setScreenData(path, value) {
  var screenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  return {
    type: SET_SCREEN_DATA_ACTION,
    path: path,
    value: value,
    screenKey: screenKey
  };
};

exports.default = setScreenData;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screen/actions/SetScreenDataAction.js
// module id = 215
// module chunks = 10